import { getCategories } from '$lib/db/categories';
import { getShopManualDiscount } from '$lib/db/discount';
import { getMenu } from '$lib/db/menu';
import { getShopByName } from '$lib/db/shop';

import type { LayoutLoad } from './$types';

export const load = (async ({ params }) => {
    // console.log("rerun");

    return {
        shop: await getShopByName(params.shopID),
        menu: await getMenu(params.shopID),
        categories: await getCategories(params.shopID),
        manualDiscounts: await getShopManualDiscount(params.shopID),
    }

}) satisfies LayoutLoad;